<template>
  <div :class="{ 'bg-white': !nightMode, 'bg-dark': nightMode }" class="p-st">
    <div class="container py-4">
      <div
        class="text-center section-head"
        data-aos="fade"
        data-aos-once="true"
        data-aos-duration="800"
      >
        <h2
          class="title"
          :class="{ pgray: !nightMode, 'text-light': nightMode }"
        >
          Skills
        </h2>
        <hr
          class="title-rule"
          :class="{ pgray: !nightMode, 'bg-secondary': nightMode }"
        />
      </div>
      <br />
      <div class="row">
        <div
          class="col-xl-4 col-bg-4 col-md-4 col-sm-12 text-center pb-5 px-4"
          v-for="(skill, idx) in skills"
          :key="skill.title"
          data-aos="fade-up"
          data-aos-offset="10"
          data-aos-delay="30"
          :style="{ 'transition-delay': idx / 4.2 + 's' }"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
          data-aos-mirror="true"
          data-aos-once="true"
        >
          <div class="bg-div"><i :class="skill.icon"></i></div>
          <div class="title2 pt-2">{{ skill.title }}</div>
          <hr
            width="50%"
            :class="{ pgray: !nightMode, 'bg-secondary': nightMode }"
          />
          <span class="title3">{{ skill.info.join(", ") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import info from "../../info";

export default {
  name: "Skills",
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      skills: info.skills,
    };
  },
};
</script>

<style scoped>
.section-head {
  margin-bottom: 2rem;
}

.title {
  font-size: clamp(1.5rem, 3vw, 1.875rem);
  font-weight: 600;
  letter-spacing: -0.02em;
}

.title-rule {
  width: 48px;
  height: 3px;
  margin: 0.75rem auto 0;
  border: none;
  background: var(--color-accent, #475569);
  opacity: 0.9;
}
.title1 {
  font-size: 24px;
  font-weight: 400;
}

.title2 {
  font-size: 20px;
  font-weight: 500;
}

.title3 {
  font-size: 16px;
  font-weight: 400;
}

.fa,
.fas {
  color: var(--color-accent, #475569);
  font-size: 2rem;
  transition: all 0.3s ease;
}

.bg-div:hover .fa,
.bg-div:hover .fas {
  transform: scale(1.05);
}
</style>
